<!-- <div class="card">
    <p class="errormessage textaligncenter fontwight700">SECURITY INFORMATION :</p>
    <p class="errormessage textaligncenter fontwight700">
     The last two successful logins are on: {{ this.logindatetime[0].successdate1}} AND {{ this.logindatetime[0].sucessdate2}}.
    </p>
    <p class="errormessage textaligncenter fontwight700">The last two unsuccessful logins are: {{this.logindatetime[0].faildate1}} AND {{this.logindatetime[0].faildate2}}</p>
</div>
<div class="custom-dialog-footer">    
    <p-button class="m-1" label="OK" (click)="okandgo()"  ></p-button> 
</div> -->
<div  class="dialog-content-max">
<div class="card">


<div class="container" *ngIf="trainigdata.length>0">

  <div class="content">
    <h2>Important Information</h2>

    <p class="subtitle">
      A Training program is being organised as per the following details:
    </p>

    <div class="grid">
      <div class="label">Product</div>
      <div class="value">{{trainigdata[0].description}}</div>

      <div class="label">Description</div>
      <div class="value">{{trainigdata[0].product}}
      </div>

      <div class="label">Date</div>
      <div class="value">{{trainigdata[0].trainingdate}}</div>

      <div class="label">Time</div>
      <div class="value">{{trainigdata[0].trainingtime}}</div>

      <div class="label">Training Link</div>
      <a class="value link"  [href]="trainigdata[0].zoomlink"
   target="_blank">{{trainigdata[0].zoomlink}}
      </a>

      <div class="label">&nbsp;</div>
      <div class="value">
        <button class="invite-btn" (click)="invteemail()">CLICK HERE TO GET AN EMAIL INVITE</button>
      </div>
    </div>
  </div>
  <hr/>

</div>

<div class="card" *ngIf="loginInfo">

 
<p class="textaligncenter fontwight700" [innerHTML]="loginInfo.training"></p>
<hr/>
  <p class="errormessage textaligncenter fontwight700">SECURITY INFORMATION :</p>

  <p class="errormessage textaligncenter fontwight700">
    The last two successful logins are on:
    {{ loginInfo.successdate1 || 'N/A' }} AND {{ loginInfo.successdate2 || 'N/A' }}.
  </p>

  <p class="errormessage textaligncenter fontwight700">
    The last two unsuccessful logins are:
    {{ loginInfo.faildate1 || 'N/A' }} AND {{ loginInfo.faildate2 || 'N/A' }}.
  </p>
</div>
</div>
</div>

<div class="custom-dialog-footer">
  <p-button class="m-1" label="OK" (click)="okandgo()"></p-button>
</div>
